import React, { useState } from 'react';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MuiChip from '@material-ui/core/Chip';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import { useRouter } from 'next/router';
import { withStyles } from '@material-ui/core';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';
import qs from 'query-string';
import Button from '@material-ui/core/Button';
import MuiTextField from '@material-ui/core/TextField';
import NumberFormat, { NumberFormatValues } from 'react-number-format';

const ExpansionPanel = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  content: {
    alignItems: 'center',
  },
})(MuiExpansionPanelSummary);

const PanelHeading = withStyles({
  h6: {
    width: '100%',
    fontWeight: 'normal',
    fontSize: '13px',
  },
})(Typography);
const Chip = styled(MuiChip)`
  font-size: 10px !important;
  background: ${({ theme }) => theme.colors.primary} !important;
`;
const Form = styled.form`
  display: flex;
  align-items: center;
  .MuiFormControl-root {
    margin-top: 10px;
    &:not(:first-child) {
      margin-left: 10px;
    }
  }
  button {
    padding: 0;
  }
`;
const StyledNumberFormat = styled(NumberFormat)`
  margin-top: 10px !important;
  width: 100%;
`;

type PriceRangePanel = {
  isWantedSearch: boolean;
};
const PriceRangePanel = ({ isWantedSearch }: PriceRangePanel) => {
  const router = useRouter();
  const { query } = router;
  const [minValue, setMinValue] = useState<string | null>(null);
  const [maxValue, setMaxValue] = useState<string | null>(null);

  const handleSubmit = () => {
    const qry = {
      ...query,
      rental_value: `${minValue}_${maxValue}`,
    };
    if (isWantedSearch) {
      router.push(`/wanted-search?${qs.stringify(qry)}`);
    } else {
      router.push(`/search?${qs.stringify(qry)}`);
    }
  };

  const clearFilterHandler = () => {
    const qry = {
      ...query,
      rental_value: `${(minValue && minValue.toString()) || ''}_${
        (maxValue && maxValue.toString()) || ''
      }`,
    };
    delete qry.rental_value;

    setMaxValue(null);
    setMinValue(null);
    if (isWantedSearch) {
      router.push(`/wanted-search?${qs.stringify(qry)}`);
    } else {
      router.push(`/search?${qs.stringify(qry)}`);
    }
  };
  const [expanded, setExpanded] = React.useState(true);

  const handlePanelChange = (event: any, isExpanded: boolean) => {
    setExpanded(!!isExpanded);
  };

  let canSearch = false;
  if (minValue && maxValue) {
    canSearch = parseInt(minValue, 10) >= 0 && parseInt(maxValue, 10) >= 0;
  }

  return (
    <ExpansionPanel defaultExpanded expanded={expanded} onChange={handlePanelChange}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <PanelHeading variant="h6">By Price range</PanelHeading>
        {query.rental_value && (
          <Chip
            size="small"
            label={`${query.rental_value.toString().split('_')[0]} to ${
              query.rental_value.toString().split('_')[1]
            } PKR`}
            onDelete={() => clearFilterHandler()}
            color="primary"
          />
        )}
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <Form>
          <StyledNumberFormat
            size="small"
            allowNegative={false}
            value={minValue}
            variant="outlined"
            placeholder="Min value"
            customInput={MuiTextField}
            label="Min value"
            type="text"
            InputLabelProps={{ shrink: true }}
            onValueChange={(val: NumberFormatValues) => {
              const { value } = val;
              setMinValue(value);
            }}
          />
          <StyledNumberFormat
            size="small"
            allowNegative={false}
            value={maxValue}
            variant="outlined"
            placeholder="Max value"
            customInput={MuiTextField}
            label="Max value"
            InputLabelProps={{ shrink: true }}
            onValueChange={(val: NumberFormatValues) => {
              const { value } = val;
              setMaxValue(value);
            }}
          />
          <Button
            disabled={!query.rental_value && !canSearch}
            onClick={() => handleSubmit()}
            color="primary"
          >
            Go
          </Button>
        </Form>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default PriceRangePanel;
